import React from 'react';
import { Trans } from '@lingui/macro';

import { Box, Link, Text } from '@rover/kibble/core';

import TogglePreference from './TogglePreference';

type Props = {
  label: string;
  onChange: (arg0: boolean) => void;
  value: boolean;
  starSitterLink: string;
};

const StarSitterFilter = ({ label, onChange, value, starSitterLink }: Props): JSX.Element => (
  <Box>
    <TogglePreference label={label} onChange={onChange} value={value} />
    <Text size="100">
      <Trans>
        <Link href={starSitterLink}>Learn more about the program</Link>
      </Trans>
    </Text>
  </Box>
);

export default React.memo(StarSitterFilter);
